import { Component, OnInit } from '@angular/core';
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {ClubsService} from "../shared/model/clubs.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-club-add',
  templateUrl: './club-add.component.html',
  styleUrls: ['./club-add.component.css']
})
export class ClubAddComponent implements OnInit {

  myForm: FormGroup;

  name: string;
  city: string;
  url: string;
  demo: boolean = false;
  distributorCode = null;
  latitude: number = 52;
  longitude: number = 5;

  isSaved: boolean = false;
  hasError: boolean = false;
  message: string = "";

  public visibleAdd = true;
  private visibleAddAnimate = false;

  constructor(private fb: FormBuilder, private clubService: ClubsService, public translate: TranslateService) {
    this.myForm = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      'city': ['', Validators.compose([Validators.required, Validators.minLength(3)])],
      'url': [''],
      'distributorCode': [''],
      'latitude': ['', Validators.compose([Validators.required])],
      'longitude': ['', Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {
    this.show();
  }

  ngOnChanges() {
  }

  public show(): void {
    this.visibleAdd = true;
    setTimeout(() => this.visibleAddAnimate = true);
  }

  public hide(): void {
    this.visibleAddAnimate = false;
    setTimeout(() => this.visibleAdd = false, 300);
  }

  public save() {
    this.isSaved = false;

    if ( this.distributorCode !== null && this.distributorCode !== '' ) {
      let val = parseInt(this.distributorCode);
      if ( val !== NaN ) {
        //console.log(`ik maak van distributorCode: ${val}`);
        this.distributorCode = val;
      } else {
        //console.log(`ik maak van distributorCode null (NaN)`);
        this.distributorCode = null;
      }
    }
    this.clubService.addClub(this.name, this.city, this.url, this.distributorCode, this.demo, this.latitude, this.longitude);
    this.translate.get('s.club')
      .subscribe((res: string) => {
        this.message = res;
        this.isSaved = true;
      });

  }

}
